module.exports = __webpack_public_path__ + "static/img/审批建议&自学习.64b46d05.png";